import { Box, Text, TextProps } from '@chakra-ui/react'
import React from 'react'

interface IErrorText extends TextProps {
  text: string
}

const ErrorText = (props: IErrorText) => {
  const { text } = props

  return (
    <Box position={'relative'}>
      <Text
        textAlign='start'
        position={'absolute'}
        top={'100%'}
        paddingX='0.2rem'
        // paddingY='0.4rem'
        color='red'
        fontSize='x-small'
      >
        {text}
      </Text>
    </Box>
  )
}

export { ErrorText }
